import { Box, Link, Paper, Typography } from '@mui/material';
import moment from 'moment';
import { NavLinkComponent } from '../../Router';
import NavLink from '../../components/NavLink';
import { DataListComponent, NoDataPaper } from '../../components/data/DataTable';
import { Payment } from '../../models/Types';
import { houseStore } from '../houses/HouseCombo';
import { moneyFormat } from '../../utils';

const styles = {
    mobileListItem: {
        display: 'flex',
        flexDirection: 'row!important',
        justifyContent: 'space-between',
        textDecoration: 'none',
        p: 2,
        gap: 2,
        alignItems: 'flex-start'
    }
}

export function buildPaymentListItem(x: Payment) {
    return <Paper component={NavLinkComponent} sx={styles.mobileListItem} elevation={2} route={[['page', 'payment'], ['id', x.Id]]}>
        <Box display="flex" flexDirection="column" flex={1} gap={.5}>
            <Link variant="h3">{houseStore.data?.find(h => h.Id == x.HouseId)?.Value}</Link>
            <Typography variant="subtitle2">{moment(x.CreateDate).calendar()}</Typography>
        </Box>
        <Box>
            <Typography variant="h3" textAlign="left">{moneyFormat(x.Sum)}</Typography>
        </Box>
    </Paper>;
}

export function noDataRenderer() {
    return <NoDataPaper title="Платежей пока нет" content={['В этом разделе будут отображаться платежи, поступившие в УК']} />;
}

export default class PaymentList extends DataListComponent<Payment> {
    renderNoData() {
        return noDataRenderer();
    }

    buildItemPaper(x: Payment, i: number) {
        return buildPaymentListItem(x);
    }
}